module.exports = __webpack_public_path__ + "static/media/Girl.8fcabafd.png";